module.exports = __webpack_public_path__ + "img/20.a998f9f0.jpg";